module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/EXXht/tc-custom/FC-9781647505165.jpg?1692133193207?1706795885959",
      "alt": "This image is the cover for the book A Luna's Dark Past"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("A Luna's Dark Past\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("Have you ever been ")]), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("in")]), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v(" a family where your parents hid things from you? Well")]), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v(",")]), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v(" that is exactly what happened to Artemis. She believed she was just a normal teenager with simple problems. But one terrifying night ")]), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("her")]), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v(" whole world turned around. She went from being a normal teenage girl to something she never believe")]), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("d")]), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v(" existed. Will Artemis be able to deal with the new world she has been thrown into? ")]), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("W")]), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("ill ")]), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("she")]), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-family": "\"Arial\",sans-serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v(" ever be normal again?")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kira Metzger\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_c('span', {
    staticStyle: {
      "font-size": "13px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("Kira Metzger is a mother of four. Writing has always been her passion. She works besides studying in a college. She wants to be a role model for her kids.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0